<div class="user-menu-name" [style.color]="wls.accentColor">
  {{ user.UserName }}
</div>
<div class="user-menu-email">
  {{ user.Email }}
</div>
<mat-divider class="user-menu-divider"></mat-divider>
@if (user.Role === 'HR' && user.CanSwitchRole) {
  <div [style.color]="wls.warnColor">
    {{ 'auth.logged-as-hr-role' | translate }}
  </div>
  <button class="user-menu-switch-button" mat-menu-item (click)="onLoginAsEmployee()">
    <mat-icon>swap_horiz</mat-icon>
    {{ 'auth.switch-to-employee-role' | translate }}
  </button>
  <mat-divider class="user-menu-divider"></mat-divider>
}
@if (user.Role === 'Employee' && user.CanSwitchRole) {
  <div [style.color]="wls.warnColor">
    {{ 'auth.logged-as-employee-role' | translate }}
  </div>
  <button class="user-menu-switch-button" mat-menu-item (click)="onLoginAsHr()">
    <mat-icon>swap_horiz</mat-icon>
    {{ 'auth.switch-to-hr-role' | translate }}
  </button>
  <mat-divider class="user-menu-divider"></mat-divider>
}
@if (user.Role === 'Employee') {
  <button
    class="user-menu-item user-menu-item_settings"
    mat-menu-item
    routerLink="/employee-account"
  >
    <mat-icon>settings</mat-icon>
    {{ 'base-layout.account' | translate }}
  </button>
} @else {
  <button class="user-menu-item user-menu-item_settings" mat-menu-item routerLink="/account">
    <mat-icon>settings</mat-icon>
    {{ 'base-layout.account' | translate }}
  </button>
}
@if (user.Role === 'HR' || user.Role === 'Employee') {
  <button
    class="user-menu-item"
    mat-menu-item
    [routerLink]="
      user.Role === 'HR' ? '/hr/notifications-center' : '/employee-notifications-center'
    "
  >
    <mat-icon>notifications_none</mat-icon>
    {{ 'notifications-center.page-title' | translate }}
  </button>
  <button class="user-menu-item" mat-menu-item (click)="openProductTourLink()">
    <mat-icon>open_in_new</mat-icon>
    {{ 'base-layout.product-tour-link' | translate }}
  </button>
}
<mat-button-toggle-group
  aria-label="Language toggle"
  class="user-menu-lang"
  name="languageToggle"
  [value]="activeLanguage"
  (change)="changeLanguage($event.value)"
>
  <mat-button-toggle style="width: 33%" value="nl">NL</mat-button-toggle>
  <mat-button-toggle style="width: 33%" value="fr">FR</mat-button-toggle>
  <mat-button-toggle style="width: 33%" value="en">EN</mat-button-toggle>
</mat-button-toggle-group>
<div class="user-menu-actions">
  <button mat-menu-item (click)="onLogout()">
    <mat-icon>exit_to_app</mat-icon>
    {{ 'base-layout.logout' | translate }}
  </button>
</div>
